import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { assignQuestionsToMe } from "../../../../api/auth";

export const PORTAL_UNIVERSITIES = [
  "Imperial College London",
  "University of Manchester",
  "University of Sheffield",
  "University of Newcastle",
  "University of Nottingham",
];

const PORTAL_COURSES = ["Medicine", "Dentistry"];

const AssignQuestionsPanel = ({ title, isMockBank, defaultUniversity = "", defaultCourse = "" }) => {
  const [university, setUniversity] = useState(defaultUniversity);
  const [course, setCourse] = useState(defaultCourse);
  const [loading, setLoading] = useState(false);
  const [lastResult, setLastResult] = useState(null);

  const handleAssign = async () => {
    if (!university || !course) {
      alert("Please select a university and course.");
      return;
    }

    setLoading(true);
    setLastResult(null);
    try {
      const response = await assignQuestionsToMe({
        university,
        course,
        is_mock_bank: isMockBank,
      });
      setLastResult(response);
      alert(
        response.assignedCount > 0
          ? `Assigned ${response.assignedCount} question(s) to you.`
          : "No matching unconfirmed questions were found."
      );
    } catch (error) {
      console.error("Assign to me failed:", error);
      alert("Failed to assign questions. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card variant="outlined" sx={{ height: "100%" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Assign all unconfirmed uploads for the selected university and course to
          yourself.
        </Typography>

        <Box display="flex" flexDirection="column" gap={2}>
          <FormControl fullWidth>
            <InputLabel id={`assign-uni-${isMockBank ? "mock" : "qb"}`}>
              University
            </InputLabel>
            <Select
              labelId={`assign-uni-${isMockBank ? "mock" : "qb"}`}
              value={university}
              label="University"
              onChange={(e) => setUniversity(e.target.value)}
            >
              {PORTAL_UNIVERSITIES.map((uni) => (
                <MenuItem key={uni} value={uni}>
                  {uni}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel id={`assign-course-${isMockBank ? "mock" : "qb"}`}>
              Course
            </InputLabel>
            <Select
              labelId={`assign-course-${isMockBank ? "mock" : "qb"}`}
              value={course}
              label="Course"
              onChange={(e) => setCourse(e.target.value)}
            >
              {PORTAL_COURSES.map((c) => (
                <MenuItem key={c} value={c}>
                  {c}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="contained"
            color="primary"
            onClick={handleAssign}
            disabled={loading}
            fullWidth
          >
            {loading ? <CircularProgress size={22} color="inherit" /> : "Assign to me"}
          </Button>

          {lastResult && (
            <Typography variant="body2" color="text.secondary">
              Last run: {lastResult.assignedCount} question(s) assigned.
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default AssignQuestionsPanel;
